import React from "react";
import { Link } from "react-router";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { RaisedButton, LinearProgress } from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import FilmActions from "../actions/FilmActions";
import FilmStore from "../stores/FilmStore";
import VirtualContentStore from "../stores/VirtualContentStore";
import VirtualContentActions from "../actions/VirtualContentActions";

import config from "../config";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";
import LinkLike from "./partials/link-like.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";

import VirtualContentUploader from "./partials/virtual-content-uploader.jsx";

import qs from "query-string";

const parsedQueryString = qs.parse(window.location.search);

class Films extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      grantingOtherContent: false,
      uploadingNewContent: false,
      uploadedContent: false
    };
  }

  static getStores() {
    return [UserStore, FilmStore, VirtualContentStore];
  }

  static getPropsFromStores() {
    return FilmStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  shouldUseBeta(film) {
    // If film._use_beta_vod_flow_for_new_virtual_content is true, returns true unless overridden by beta=0 in the query string.
    // If film._use_beta_vod_flow_for_new_virtual_content is false, returns false unless overridden by beta=1 in the query string.
    if (parsedQueryString.beta === "1") {
      return true;
    }
    if (parsedQueryString.beta === "0") {
      return false;
    }
    return film._use_beta_vod_flow_for_new_virtual_content;
  }

  getStyles() {
    return {
      container: {
        maxWidth: 500,
        margin: "5% auto",
        fontSize: "11pt",
        padding: "5px 20px",
        borderRadius: "1em",
        boxShadow: "0 0 20px 2px rgba(0,0,0,0.2)"
      }
    };
  }

  componentWillMount() {
    FilmActions.fetchOne(this.props.params.filmId);
    VirtualContentActions.fetchAll();
  }

  render() {
    let styles = this.getStyles(),
      film = FilmStore.getFilmById(this.props.params.filmId),
      existingVirtualContent =
        this.state.uploadedContent || (film && film.virtual_content);

    if (
      this.state.grantingOtherContent ||
      !film ||
      this.props.isFetching ||
      VirtualContentStore.getState().isFetching
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div style={styles.container}>
        <p>
          <strong>{film.owner_organization}</strong> has invited you to upload
          content for <strong>{film.name}</strong>, screening within{" "}
          <strong>{film.event_bucket_name}</strong>.
        </p>
        <p>
          Your content will be protected with multi-platform DRM and invisible
          per-user{" "}
          <a href="https://eventive.org/antipiracy" target="_blank">
            forensic watermarking
          </a>
          , encoded for optimal playback across a variety of streaming
          environments, geo-blocked and audience restricted as required, and
          delivered securely to authorized viewers.
        </p>
        {/* <p>
          <InlineNoticeLabel
            style={{ fontWeight: "bold" }}
            label="NEW FEATURE"
          />{" "}
          In addition to closed captions, descriptive audio tracks are now
          supported!{" "}
          <a href="https://help.eventive.org/" target="_blank">
            Learn how to prepare and upload accessible content.
          </a>
        </p> */}
        {/* <p>
          <InlineNoticeLabel label="NEW" /> Up to 4K UHD resolution is now
          supported! The maximum bitrate for uploaded content is 10 Mbps.
        </p> */}
        {this.state.uploadedContent ||
        (existingVirtualContent &&
          [
            "pending_upload",
            "vod_upload_started",
            "vod_upload_failure"
          ].indexOf(existingVirtualContent.status) === -1 &&
          !this.state.uploadingNewContent) ? (
          <div
            style={{
              margin: "2em 0",
              border: "2px dashed #ccc",
              borderRadius: 5,
              paddingLeft: "2em",
              paddingRight: "2em",
              textAlign: "center"
            }}
          >
            {existingVirtualContent ? (
              <p>
                You have successfully uploaded "{existingVirtualContent.label}".
                Thank you.
              </p>
            ) : (
              <p>Your content has been uploaded. Thank you.</p>
            )}

            <p style={{ marginTop: "-0.75em" }}>
              {existingVirtualContent ? (
                <span>
                  <Link
                    to={`/creator_hub/virtual_content/${existingVirtualContent.id}`}
                  >
                    Manage asset
                  </Link>{" "}
                  &middot;{" "}
                </span>
              ) : null}
              <LinkLike
                onTouchTap={() =>
                  Intercom(
                    "showNewMessage",
                    `Please revoke access to ${film.name} from ${film.event_bucket_name} / ${film.owner_organization} (ref # ${film.id}).`
                  )
                }
              >
                Revoke access
              </LinkLike>
            </p>
          </div>
        ) : (
          <div>
            <div
              style={{
                margin: "2em 0 1.5em"
              }}
            >
              <VirtualContentUploader
                useBeta={film._use_beta_vod_flow_for_new_virtual_content}
                filmId={film.id}
                onSuccess={content => {
                  this.setState({ uploadedContent: content });
                }}
                existingVirtualContentId={
                  existingVirtualContent ? existingVirtualContent.id : undefined
                }
                noFetchOther={true}
                otherContentStyle={{
                  marginTop: "1.5em",
                  padding: "1em 1em 0",
                  border: "1px dashed #ccc",
                  borderRadius: "1em"
                }}
                otherContentIntroduction={
                  <div style={{ fontStyle: "italic" }}>
                    You have previously uploaded content that can be used for
                    this screening. To grant access, select an item below.
                  </div>
                }
                onOtherContentSelect={content => {
                  if (
                    window.confirm(
                      `Are you sure you would like to grant access to "${
                        content.label || "Unlabeled content"
                      }" to ${
                        film.owner_organization
                      }? The content will be shared immediately.`
                    )
                  ) {
                    this.setState({ grantingOtherContent: true });
                    VirtualContentActions.edit(content.id, {
                      _films: [film.id]
                    });
                    setTimeout(() => {
                      this.setState({
                        grantingOtherContent: false,
                        uploadedContent: content
                      });
                    }, 1500);
                  }
                }}
              />
            </div>
            {/* <p>
              We recommend you upload an H.264 video file encoded at 10 Mbps. If
              possible, select "High Profile" H.264 setting instead of "Main
              Profile" when you export your video.
            </p> */}
          </div>
        )}
        {true ? (
          <p style={{ textAlign: "center", color: "rgba(0,0,0,0.6)" }}>
            Powered by Eventive Media
          </p>
        ) : (
          <p style={{ textAlign: "center", color: "rgba(0,0,0,0.6)" }}>
            Eventive Media powered by{" "}
            <a href="https://cinesend.com" target="_blank">
              <svg
                viewBox="0 0 603 142.7"
                alt="CineSend"
                style={{
                  width: 80,
                  height: 40,
                  verticalAlign: -15,
                  marginLeft: "0.1em"
                }}
              >
                <path
                  fill="#FB0F3B"
                  d="M330.9 26.7c36.6-10 73.6-18.2 110.9-25.3h.1c2.4-.3 4.6-1.1 6.9-.1.8.3 1.3 1.2 1.2 2-.1.9-.7 1.7-1.7 1.9C430 8.7 412 13.8 393.9 18c-17.7 5.2-36.1 9.4-52.2 18.7-5.8 4.2-12 8.9-14.7 15.8-1.7 3.7-.8 8.1 1.2 11.5 8.6 14.6 26.1 24 29.6 40.9.9 4.2 1.8 11.6-2.3 15.6-4.1 4.3-10.1 6.1-15.7 7.6-13.4 3.2-27.1 4.1-40.8 5.6-29.8 3.2-59.7 5.2-89.7 7.1-14.6.9-28.9.4-43.3.6-.7 0-1.1-.7-.8-1.3 0-.1.1-.1.1-.2.2-.5.7-.8 1.2-.8 25.7-1.9 51.4-3.9 77.1-6.9 17.1-2.1 34.5-4.4 50.8-10.3 9.9-4.1 20.6-9.7 24.8-20.2 3.5-7.9-1.6-16.3-6.1-22.6-7.1-7.9-17.2-13.6-21.4-23.8-2-5.7-.3-12.2 4.7-15.8 10.3-7.1 22.8-9.5 34.5-12.8z"
                ></path>
                <path
                  fill="#353149"
                  d="M14.2 26c7.5-9.4 19.1-14.6 30.9-15.9 14-1.6 29.5-.3 41 8.5 9.4 6.9 13.9 18.5 14.9 29.8-5.6-.1-11.1.3-16.7-.2-7.8-1.3-8.2-11.1-14.5-14.7C57.2 26.4 38.3 29 30.4 42c-6 10.1-6.1 22.4-5.1 33.8 1 10.9 6.7 22.6 17.6 26.7 9.2 3.1 20.5 2.7 28.4-3.6 4.6-3.7 6.4-9.6 8.5-14.9 7.1.1 14.2 0 21.4 0-1 11.7-5.9 23.5-15.4 30.8-10.7 8.1-24.7 10.2-37.8 9.4-11.4-.6-23.2-4.5-31.1-13.1C5.5 99.7 2.1 82.7 3 67.1 2.2 52.7 4.9 37.4 14.2 26z"
                ></path>
                <path
                  fill="#FB0F3B"
                  d="M575.8 43.4c.2-10.8-.1-21.6.2-32.5 4.6.2 9.2-.1 13.8.2 5.5.2 10 5.4 9.9 10.8.1 19.9 0 39.8.1 59.7 0 11.6-.6 25.2-10.2 33.2-9.4 7.1-21.5 10.3-33.2 9.6-10.8.2-22.9-2.6-29.6-11.8-8.6-11.8-9.1-27.2-8.1-41.3.8-11.6 5.2-23.4 14.4-30.9 8.4-7 20.3-7.7 30.6-5.1 4.8 1.3 8.4 5 12.1 8.1z"
                ></path>
                <path
                  fill="#353149"
                  d="M111.1 13c6.5.4 14.9-2.4 19.5 3.7 3.3 3.7 2.2 9 2 13.5-7.2-.2-14.3-.1-21.5-.1V13z"
                ></path>
                <path
                  fill="#FB0F3B"
                  d="M370 42.2c9.9-8.5 24-9 36.3-7.1 10.4 1.5 19.9 8.1 24.6 17.5 5.3 10.4 5.5 22.5 5.5 33.9-18.3.8-36.7-.1-55.1.5 1 5.8 3.3 12.3 9.1 15 5.9 3.5 13.9 1.4 18.1-3.7 1.4-1.4 2.7-3.2 4.9-3.4 7.1-.2 14.3-.2 21.4-.3-.6 12.9-10.6 24-22.6 27.9-7 2.6-14.6 2.1-21.9 2-12.1-.2-23.7-7.8-28.8-18.8-5.6-10.5-5.3-22.8-4.8-34.3.7-11 4.7-22.2 13.3-29.2zM450.6 42.7c12.3-8.7 28.7-10.7 43-6.3 7.4 2.4 14.8 6.5 18.5 13.6 2.7 5.7 3.5 12.1 3.9 18.3.2 18.2-.1 36.4.3 54.7-5.5.4-11.1.6-16.5-.2-4.4-.8-8.1-4.7-8-9.3-.2-15.5.1-31-.1-46.4-.2-9.3-12-15.8-19.8-10.6-4.7 1.9-6.9 7.1-6.9 11.9-.3 18.3.4 36.6-.3 54.9-8.1-.2-16.2-.1-24.3-.1.2-18.8 0-37.5.1-56.3.4-8.7 2.5-18.7 10.1-24.2z"
                ></path>
                <path
                  fill="#353149"
                  d="M145.8 45.4c15.6-12.7 39.9-13.1 55.6-.5 7.2 6.7 8.7 17.2 8.9 26.5-.1 16.9.3 33.8-.2 50.7-4.5-.2-9 .1-13.4-.4-4.5-.7-8-5.1-8.1-9.6-.2-15.5.2-31-.1-46.5-.6-10.9-15.1-15.6-23.4-9.8-4.5 2.5-6.1 7.9-6 12.7-.2 17.9.7 35.8-.1 53.6-7.3-.2-14.5-.1-21.7-.1.1-17.3 0-34.7 0-52 .1-8.8 2-18.3 8.5-24.6zM221.9 51.4c5.1-8.6 14.4-14.3 24.3-15.5 13-1.8 28.1 1 36.7 11.7 8.5 10.5 9.9 24.7 9.4 37.7-18.3.1-36.6-.1-55 .1.6 5 1.2 10.5 4.9 14.3 4.8 5.6 13.3 6.4 19.8 3.7 4.7-1.5 6.5-7.6 11.8-7.7 5.7-.5 11.5-.1 17.2-.2-2.3 11.8-11.2 21.9-22.7 25.5-11.2 3.6-24.1 3.4-34.6-2.3-10.7-6.1-16.7-18-18-30-1.2-12.5-.8-26.2 6.2-37.3zM111 37.9c6.5.2 15-2.5 19.5 3.6 3.2 3.4 2.2 8.4 2.3 12.6-.3 22.7.7 45.4-.1 68.1-7.3-.2-14.6-.1-21.9-.1-.2-28.2.6-56.2.2-84.2z"
                ></path>
                <path
                  fill="#FFF"
                  d="M247.2 55c5.9-2 13.4-1.6 18 3.2 3.2 3.4 4.1 8.2 4.4 12.7h-32.1c0-6.5 3.3-13.4 9.7-15.9zM381.5 69.8c.6-8.1 7.7-15.4 16.1-14.3 7.5.1 12.7 7.4 12.8 14.5-9.6-.8-19.2.5-28.9-.2zM555.5 56.3c5.8-1.7 12.1 1.5 15.6 6.1 3.5 5.1 4.6 11.5 4.7 17.6-.7 6.6-1.5 14-6.3 19.1-3.8 3.5-9.5 5.8-14.6 3.7-9.4-2.9-12.5-13.9-12.7-22.7-.3-9.3 3.4-20.9 13.3-23.8z"
                ></path>
              </svg>
            </a>
          </p>
        )}
      </div>
    );
  }
}

export default connectToStores(Films);



// WEBPACK FOOTER //
// ./src/app/components/creator-film.jsx